import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

export const LANGS = [
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "en", label: "EN", name: "English" },
];

const IMG = {
  hausFront: "/images/haus-front.jpg",
  flurZimmer: "/images/flur-zimmer.jpg",
  innenKommode: "/images/innen-kommode.jpg",
  hausNacht: "/images/haus-nacht.jpg",
  zimmer4: "/images/zimmer-4bett.jpg",
  zimmer2: "/images/zimmer-2bett.jpg",
  amper: "/images/amper.jpg",
  muenchen: "/images/muenchen-olympiapark.jpg",
};

export const heroImages = {
  house: IMG.hausFront,
  room: IMG.zimmer4,
  faq: IMG.innenKommode,
};

const de = {
  nav: [
    { id: "start", label: "Startseite" },
    { id: "pension", label: "Die Pension" },
    { id: "ausstattung", label: "Ausstattung" },
    { id: "preise", label: "Preise" },
    { id: "bilder", label: "Bilder" },
    { id: "guending", label: "Über Günding" },
    { id: "kontakt", label: "Kontakt" },
  ],
  navCta: "Anfrage senden",
  navCall: "Jetzt anrufen",
  navMail: "E-Mail schreiben",
  menuOpen: "Menü öffnen",
  menuClose: "Menü schließen",
  hero: {
    badge: "München und Umgebung",
    titleTop: "Willkommen bei der",
    titleBottom: "Pension Günding Gästehaus",
    lead:
      "Günstig wohnen mit Anmeldung. Kostenfreies WLAN in allen Bereichen, kostenlose Privatparkplätze am Haus und eine Gemeinschaftsküche – nur 2,37 km vom Stadtzentrum Dachau.",
    ctaPrimary: "Zimmer anfragen",
    checks: ["Kostenloses WLAN", "Gratis Parkplätze", "Gemeinschaftsküche", "Mit Anmeldung"],
    priceLabel: "Preis",
    priceValue: "ab 15 €",
    priceNote: "1 Bett für eine Nacht",
    stamp: "Mit Anmeldung",
    houseAlt: "Pension Günding Gästehaus an der Brucker Straße 24",
    marquee: [
      "Brucker Straße 24, 85232 Günding",
      "2,37 km vom Stadtzentrum Dachau",
      "18 km bis München",
      "31 km bis Flughafen München",
      "39 km bis Augsburg",
      "Wir sprechen Deutsch & Englisch",
    ],
  },
  quickFacts: [
    { icon: "Wifi", title: "Kostenloses WLAN", text: "In allen Bereichen der Unterkunft nutzbar." },
    { icon: "CircleParking", title: "Kostenlose Parkplätze", text: "Private Parkplätze am Haus – ohne Reservierung." },
    { icon: "CookingPot", title: "Gemeinschaftsküche", text: "Eigene Mahlzeiten bequem selbst zubereiten." },
    { icon: "FileCheck2", title: "Mit Anmeldung", text: "Wohnen mit Anmeldung möglich." },
    { icon: "Languages", title: "Wir sprechen Ihre Sprache", text: "Deutsch und Englisch vor Ort." },
  ],
  welcome: {
    eyebrow: "Die Pension",
    title: "Willkommen bei der Pension Günding Gästehaus",
    roomAlt: "Gästezimmer der Pension Günding Gästehaus",
    badgeValue: "2,37 km",
    badgeLabel: "bis Dachau Zentrum",
    address: [
      "Brucker Straße 24",
      "85232 Günding",
      "2,37 km vom Stadtzentrum Dachau, Deutschland",
    ],
    paragraphs: [
      "Die Pension Günding Gästehaus bietet kostenfreies WLAN in allen Bereichen, Unterkünfte in Günding sowie kostenlose Privatparkplätze am Haus.",
      "In der Gemeinschaftsküche der Unterkunft bereiten Sie bequem Ihre eigenen Mahlzeiten zu.",
      "München liegt 18 km von der Pension Günding Gästehaus entfernt und Augsburg erreichen Sie nach 39 km. Vom nächstgelegenen Flughafen München trennen Sie in der Unterkunft 31 km.",
    ],
    highlight: "Wir sprechen Ihre Sprache!",
    languagesLabel: "Gesprochene Sprachen",
    languages: ["Deutsch", "Englisch"],
    joiner: " und ",
  },
  roomFeatures: [
    { icon: "BedDouble", label: "Bett & Bettwäsche" },
    { icon: "Wifi", label: "Kostenloses WLAN" },
    { icon: "WashingMachine", label: "Waschmaschine" },
    { icon: "DoorClosed", label: "Kleiderschrank" },
    { icon: "Thermometer", label: "Heizung" },
    { icon: "ShowerHead", label: "Sanitärbereich" },
  ],
  amenitiesSection: {
    eyebrow: "Ausstattung",
    title: "Alles, was Sie brauchen",
    lead: "Die Ausstattung der Pension Günding Gästehaus im Überblick – von kostenfreiem WLAN bis zur Gemeinschaftsküche.",
    freeBadge: "Kostenlos",
  },
  amenities: [
    { icon: "Wifi", title: "Internet", free: true, items: ["WLAN in allen Bereichen nutzbar", "Ohne Zusatzkosten"] },
    { icon: "CircleParking", title: "Parkmöglichkeiten", free: true, items: ["Private Parkplätze am Haus", "Keine Reservierung erforderlich"] },
    { icon: "CookingPot", title: "Küche", items: ["Gemeinschaftsküche", "Eigene Mahlzeiten zubereiten"] },
    { icon: "Flower2", title: "Außenbereich", items: ["Terrasse", "Sitzplätze im Freien"] },
    { icon: "WashingMachine", title: "Dienstleistungen", items: ["Waschsalon", "Wäscheservice"] },
    { icon: "Info", title: "Allgemein", items: ["Nur für Erwachsene", "Nichtraucherzimmer", "Raucherbereich vorhanden", "Heizung"] },
    { icon: "Languages", title: "Gesprochene Sprachen", items: ["Deutsch", "Englisch"] },
    { icon: "PawPrint", title: "Haustiere", items: ["Haustiere sind nicht gestattet"] },
  ],
  prices: {
    eyebrow: "Preise",
    title: "Preise im Schnellüberblick",
    lead: "Faire Preise für eine Nacht oder einen längeren Aufenthalt – günstig wohnen mit Anmeldung in Günding bei Dachau.",
    includes: [
      "Kostenfreies WLAN inklusive",
      "Kostenlose Privatparkplätze am Haus",
      "Nutzung der Gemeinschaftsküche",
      "Waschsalon / Wäscheservice",
    ],
    cardEyebrow: "Bestpreis",
    amount: "15 €",
    per: "/ Bett / Nacht",
    sub: "1 Bett für eine Nacht ab 15 €.",
    note: "Weitere Preise, Verfügbarkeiten und Angebote für längere Aufenthalte erhalten Sie gerne persönlich – telefonisch oder per E-Mail.",
    ctaCall: "Preis erfragen",
    ctaMail: "E-Mail senden",
  },
  gallerySection: {
    eyebrow: "Bilder",
    title: "Einblicke in die Pension",
    lead: "Haus, Zimmer und die Umgebung an der Amper – original aufgenommen in Günding.",
    tags: { all: "Alle", haus: "Haus", innen: "Innenbereich", zimmer: "Zimmer", umgebung: "Umgebung" },
  },
  gallery: [
    { src: IMG.hausFront, tag: "haus", alt: "Pension Günding Gästehaus an der Brucker Straße 24", caption: "Die Pension an der Brucker Straße 24" },
    { src: IMG.hausNacht, tag: "haus", alt: "Pension Günding Gästehaus bei Nacht", caption: "Stimmungsvolle Beleuchtung am Abend" },
    { src: IMG.flurZimmer, tag: "innen", alt: "Heller Flur zu den Gästezimmern", caption: "Gepflegter Flur zu den Gästezimmern" },
    { src: IMG.innenKommode, tag: "innen", alt: "Aufenthaltsbereich mit Kommode und Spiegel", caption: "Wohnlicher Aufenthaltsbereich" },
    { src: IMG.zimmer4, tag: "zimmer", alt: "Mehrbettzimmer mit Tisch und Schränken", caption: "Mehrbettzimmer mit Essbereich und Schränken" },
    { src: IMG.zimmer2, tag: "zimmer", alt: "Zimmer mit zwei Betten und TV", caption: "Zimmer mit TV, Sitzgruppe und Schrank" },
    { src: IMG.amper, tag: "umgebung", alt: "Kanufahrer auf der Amper bei Günding", caption: "Die Amper – nur wenige Schritte entfernt" },
    { src: IMG.muenchen, tag: "umgebung", alt: "Olympiapark München", caption: "München – 18 km entfernt" },
  ],
  lightbox: { close: "Schließen", prev: "Vorheriges Bild", next: "Nächstes Bild" },
  guending: {
    eyebrow: "Lage & Umgebung",
    title: "Über Günding",
    paragraphs: [
      "Günding ist ein Ortsteil der Gemeinde Bergkirchen im Landkreis Dachau. Er liegt am Rande der Stadt Dachau und hat ungefähr 1.200 Einwohner. Bis zur Gebietsreform in den 1970er Jahren bildete Günding zusammen mit dem Nachbardorf Mitterndorf eine eigenständige Gemeinde. Am 1. Mai 1978 wurde die Gemeinde Günding aufgelöst und in die neue Großgemeinde Bergkirchen eingegliedert.",
      "Der Ort liegt etwa zwei Kilometer westlich von Dachau an der Amper. Nach Breitenau im Westen sind es 1,7 km. Nach München sind es 24 km. Zur Bundesautobahn 8 mit der Anschlussstelle Dachau-Fürstenfeldbruck fährt man Richtung Südwesten 4 km.",
    ],
    facts: [
      { label: "Einwohner", value: "ca. 1.200" },
      { label: "Gemeinde", value: "Bergkirchen" },
      { label: "Landkreis", value: "Dachau" },
      { label: "Fluss", value: "Amper" },
    ],
    amperAlt: "Die Amper bei Günding",
    distancesTitle: "Entfernungen",
    distances: [
      { icon: "MapPin", place: "Stadtzentrum Dachau", km: "2,37 km" },
      { icon: "TreePine", place: "Breitenau", km: "1,7 km" },
      { icon: "Milestone", place: "Autobahn A8 (Dachau-Fürstenfeldbruck)", km: "4 km" },
      { icon: "Building2", place: "München", km: "18 km" },
      { icon: "Plane", place: "Flughafen München", km: "31 km" },
      { icon: "Landmark", place: "Augsburg", km: "39 km" },
    ],
  },
  faqSection: {
    eyebrow: "Häufige Fragen",
    title: "Gut zu wissen",
    lead: "Die wichtigsten Antworten rund um Ihren Aufenthalt in der Pension Günding Gästehaus.",
  },
  faqs: [
    { q: "Ist eine Anmeldung (Wohnsitzanmeldung) möglich?", a: "Ja. Die Pension Günding Gästehaus bietet günstiges Wohnen mit Anmeldung – sprechen Sie uns einfach telefonisch darauf an." },
    { q: "Was kostet eine Übernachtung?", a: "1 Bett für eine Nacht ab 15 Euro. Für längere Aufenthalte und individuelle Anfragen erhalten Sie Ihren Preis gerne telefonisch oder per E-Mail." },
    { q: "Gibt es Parkplätze?", a: "Ja, private Parkplätze stehen kostenfrei direkt an der Unterkunft zur Verfügung. Eine Reservierung ist nicht erforderlich." },
    { q: "Kann ich selbst kochen?", a: "In der Gemeinschaftsküche der Unterkunft bereiten Sie bequem Ihre eigenen Mahlzeiten zu." },
    { q: "Sind Haustiere erlaubt?", a: "Haustiere sind leider nicht gestattet." },
    { q: "Welche Sprachen werden gesprochen?", a: "Wir sprechen Deutsch und Englisch – wir sprechen Ihre Sprache!" },
  ],
  contactSection: {
    eyebrow: "Kontakt",
    title: "Wir freuen uns auf Sie",
    lead: "Rufen Sie uns an, schreiben Sie eine E-Mail oder senden Sie Ihre Anfrage direkt über das Formular.",
    addressTitle: "Adresse",
    mapTitle: "Karte Pension Günding Gästehaus",
    route: "Route in Google Maps planen",
    formTitle: "Anfrage senden",
    formNote: "Ihre Anfrage wird direkt an die Pension Günding Gästehaus gesendet. Sie erhalten zusätzlich eine Bestätigung per E-Mail.",
    name: "Name",
    namePh: "Ihr Name",
    email: "E-Mail",
    emailPh: "ihre@email.de",
    phone: "Telefon",
    phonePh: "Optional",
    message: "Nachricht",
    messagePh: "Zeitraum, Anzahl Personen, Fragen …",
    submit: "Anfrage absenden",
    sending: "Wird gesendet …",
    errTitle: "Bitte Felder ausfüllen",
    errText: "Name, E-Mail und Nachricht sind erforderlich.",
    okTitle: "Anfrage gesendet",
    okText: "Vielen Dank! Wir melden uns so schnell wie möglich. Eine Bestätigung ist auf dem Weg in Ihr Postfach.",
    failTitle: "Senden fehlgeschlagen",
    failText: "Bitte versuchen Sie es später erneut oder rufen Sie uns an.",
  },
  footer: {
    text: "Günstig wohnen mit Anmeldung – kostenfreies WLAN, kostenlose Privatparkplätze und eine Gemeinschaftsküche. 2 km von Dachau, 18 km von München.",
    highlight: "Wir sprechen Ihre Sprache!",
    navTitle: "Navigation",
    contactTitle: "Kontakt",
    top: "Nach oben",
  },
  legalLinks: [
    { to: "/impressum", label: "Impressum" },
    { to: "/datenschutz", label: "Datenschutzerklärung" },
    { to: "/hausordnung", label: "Buchungs- und Hausordnung" },
  ],
  whatsapp: {
    cta: "Per WhatsApp schreiben",
    short: "WhatsApp",
    aria: "Chat per WhatsApp mit der Pension Günding Gästehaus öffnen",
    hint: "Fragen? Schreiben Sie uns direkt per WhatsApp.",
    hintClose: "Hinweis schließen",
    note: "Ihre Nachricht geht direkt an unser Telefon – es antwortet immer ein Mensch, kein Bot.",
    prefill:
      "Hallo Pension Günding Gästehaus, ich habe eine Frage zu einem Zimmer (Zeitraum, Anzahl Personen): ",
  },
  legalBack: "Zurück zur Startseite",
  legalGermanNote: null,
};

const en = {
  nav: [
    { id: "start", label: "Home" },
    { id: "pension", label: "The guesthouse" },
    { id: "ausstattung", label: "Facilities" },
    { id: "preise", label: "Prices" },
    { id: "bilder", label: "Photos" },
    { id: "guending", label: "About Günding" },
    { id: "kontakt", label: "Contact" },
  ],
  navCta: "Send enquiry",
  navCall: "Call us now",
  navMail: "Write an email",
  menuOpen: "Open menu",
  menuClose: "Close menu",
  hero: {
    badge: "Munich and surroundings",
    titleTop: "Welcome to",
    titleBottom: "Pension Günding Gästehaus",
    lead:
      "Affordable living with official residence registration. Free Wi-Fi throughout, free private parking at the house and a shared kitchen – just 2.37 km from Dachau town centre.",
    ctaPrimary: "Request a room",
    checks: ["Free Wi-Fi", "Free parking", "Shared kitchen", "Registration possible"],
    priceLabel: "Price",
    priceValue: "from €15",
    priceNote: "1 bed for one night",
    stamp: "With registration",
    houseAlt: "Pension Günding Gästehaus at Brucker Straße 24",
    marquee: [
      "Brucker Straße 24, 85232 Günding",
      "2.37 km from Dachau town centre",
      "18 km to Munich",
      "31 km to Munich Airport",
      "39 km to Augsburg",
      "We speak German & English",
    ],
  },
  quickFacts: [
    { icon: "Wifi", title: "Free Wi-Fi", text: "Available in all areas of the property." },
    { icon: "CircleParking", title: "Free parking", text: "Private parking at the house – no reservation needed." },
    { icon: "CookingPot", title: "Shared kitchen", text: "Prepare your own meals comfortably." },
    { icon: "FileCheck2", title: "Registration", text: "Living with official registration is possible." },
    { icon: "Languages", title: "We speak your language", text: "German and English on site." },
  ],
  welcome: {
    eyebrow: "The guesthouse",
    title: "Welcome to Pension Günding Gästehaus",
    roomAlt: "Guest room at Pension Günding Gästehaus",
    badgeValue: "2.37 km",
    badgeLabel: "to Dachau centre",
    address: [
      "Brucker Straße 24",
      "85232 Günding",
      "2.37 km from Dachau town centre, Germany",
    ],
    paragraphs: [
      "Pension Günding Gästehaus offers free Wi-Fi in all areas, accommodation in Günding and free private parking at the house.",
      "In the shared kitchen you can comfortably prepare your own meals.",
      "Munich is 18 km from Pension Günding Gästehaus and Augsburg is 39 km away. The nearest airport, Munich Airport, is 31 km from the property.",
    ],
    highlight: "We speak your language!",
    languagesLabel: "Languages spoken",
    languages: ["German", "English"],
    joiner: " and ",
  },
  roomFeatures: [
    { icon: "BedDouble", label: "Bed & linen" },
    { icon: "Wifi", label: "Free Wi-Fi" },
    { icon: "WashingMachine", label: "Washing machine" },
    { icon: "DoorClosed", label: "Wardrobe" },
    { icon: "Thermometer", label: "Heating" },
    { icon: "ShowerHead", label: "Bathroom facilities" },
  ],
  amenitiesSection: {
    eyebrow: "Facilities",
    title: "Everything you need",
    lead: "The facilities of Pension Günding Gästehaus at a glance – from free Wi-Fi to the shared kitchen.",
    freeBadge: "Free",
  },
  amenities: [
    { icon: "Wifi", title: "Internet", free: true, items: ["Wi-Fi available in all areas", "No extra charge"] },
    { icon: "CircleParking", title: "Parking", free: true, items: ["Private parking at the house", "No reservation needed"] },
    { icon: "CookingPot", title: "Kitchen", items: ["Shared kitchen", "Prepare your own meals"] },
    { icon: "Flower2", title: "Outdoors", items: ["Terrace", "Outdoor seating"] },
    { icon: "WashingMachine", title: "Services", items: ["Laundry room", "Laundry service"] },
    { icon: "Info", title: "General", items: ["Adults only", "Non-smoking rooms", "Designated smoking area", "Heating"] },
    { icon: "Languages", title: "Languages spoken", items: ["German", "English"] },
    { icon: "PawPrint", title: "Pets", items: ["Pets are not allowed"] },
  ],
  prices: {
    eyebrow: "Prices",
    title: "Prices at a glance",
    lead: "Fair rates for a single night or a longer stay – affordable living with registration in Günding near Dachau.",
    includes: [
      "Free Wi-Fi included",
      "Free private parking at the house",
      "Use of the shared kitchen",
      "Laundry room / laundry service",
    ],
    cardEyebrow: "Best rate",
    amount: "€15",
    per: "/ bed / night",
    sub: "1 bed for one night from €15.",
    note: "For further rates, availability and offers for longer stays, simply contact us by phone or email.",
    ctaCall: "Ask for a price",
    ctaMail: "Send an email",
  },
  gallerySection: {
    eyebrow: "Photos",
    title: "A look inside the guesthouse",
    lead: "House, rooms and the surroundings along the river Amper – all photographed in Günding.",
    tags: { all: "All", haus: "House", innen: "Interior", zimmer: "Rooms", umgebung: "Surroundings" },
  },
  gallery: [
    { src: IMG.hausFront, tag: "haus", alt: "Pension Günding Gästehaus at Brucker Straße 24", caption: "The guesthouse at Brucker Straße 24" },
    { src: IMG.hausNacht, tag: "haus", alt: "Pension Günding Gästehaus at night", caption: "Atmospheric lighting in the evening" },
    { src: IMG.flurZimmer, tag: "innen", alt: "Bright corridor leading to the guest rooms", caption: "Well-kept corridor to the guest rooms" },
    { src: IMG.innenKommode, tag: "innen", alt: "Lounge area with sideboard and mirror", caption: "Homely lounge area" },
    { src: IMG.zimmer4, tag: "zimmer", alt: "Multi-bed room with table and wardrobes", caption: "Multi-bed room with dining area and wardrobes" },
    { src: IMG.zimmer2, tag: "zimmer", alt: "Room with two beds and TV", caption: "Room with TV, seating area and wardrobe" },
    { src: IMG.amper, tag: "umgebung", alt: "Canoeists on the river Amper near Günding", caption: "The river Amper – just a few steps away" },
    { src: IMG.muenchen, tag: "umgebung", alt: "Olympiapark Munich", caption: "Munich – 18 km away" },
  ],
  lightbox: { close: "Close", prev: "Previous image", next: "Next image" },
  guending: {
    eyebrow: "Location & surroundings",
    title: "About Günding",
    paragraphs: [
      "Günding is a district of the municipality of Bergkirchen in the Dachau county. It lies on the edge of the town of Dachau and has around 1,200 inhabitants. Until the administrative reform of the 1970s, Günding and the neighbouring village of Mitterndorf formed an independent municipality. On 1 May 1978 the municipality of Günding was dissolved and incorporated into the larger municipality of Bergkirchen.",
      "The village is situated about two kilometres west of Dachau on the river Amper. Breitenau to the west is 1.7 km away and Munich is 24 km away. The A8 motorway with the Dachau-Fürstenfeldbruck junction is 4 km to the south-west.",
    ],
    facts: [
      { label: "Inhabitants", value: "approx. 1,200" },
      { label: "Municipality", value: "Bergkirchen" },
      { label: "County", value: "Dachau" },
      { label: "River", value: "Amper" },
    ],
    amperAlt: "The river Amper near Günding",
    distancesTitle: "Distances",
    distances: [
      { icon: "MapPin", place: "Dachau town centre", km: "2.37 km" },
      { icon: "TreePine", place: "Breitenau", km: "1.7 km" },
      { icon: "Milestone", place: "A8 motorway (Dachau-Fürstenfeldbruck)", km: "4 km" },
      { icon: "Building2", place: "Munich", km: "18 km" },
      { icon: "Plane", place: "Munich Airport", km: "31 km" },
      { icon: "Landmark", place: "Augsburg", km: "39 km" },
    ],
  },
  faqSection: {
    eyebrow: "Frequently asked",
    title: "Good to know",
    lead: "The most important answers about your stay at Pension Günding Gästehaus.",
  },
  faqs: [
    { q: "Is official residence registration possible?", a: "Yes. Pension Günding Gästehaus offers affordable living with registration – simply ask us by phone." },
    { q: "How much does one night cost?", a: "1 bed for one night from €15. For longer stays and individual requests we are happy to quote a price by phone or email." },
    { q: "Is parking available?", a: "Yes, private parking is available free of charge directly at the property. No reservation is needed." },
    { q: "Can I cook for myself?", a: "In the shared kitchen you can comfortably prepare your own meals." },
    { q: "Are pets allowed?", a: "Unfortunately, pets are not allowed." },
    { q: "Which languages do you speak?", a: "We speak German and English – we speak your language!" },
  ],
  contactSection: {
    eyebrow: "Contact",
    title: "We look forward to meeting you",
    lead: "Give us a call, send an email or submit your enquiry directly through the form.",
    addressTitle: "Address",
    mapTitle: "Map of Pension Günding Gästehaus",
    route: "Get directions in Google Maps",
    formTitle: "Send an enquiry",
    formNote: "Your enquiry is sent directly to Pension Günding Gästehaus. You will also receive a confirmation by email.",
    name: "Name",
    namePh: "Your name",
    email: "Email",
    emailPh: "your@email.com",
    phone: "Phone",
    phonePh: "Optional",
    message: "Message",
    messagePh: "Dates, number of guests, questions …",
    submit: "Send enquiry",
    sending: "Sending …",
    errTitle: "Please complete the form",
    errText: "Name, email and message are required.",
    okTitle: "Enquiry sent",
    okText: "Thank you! We will get back to you as soon as possible. A confirmation is on its way to your inbox.",
    failTitle: "Sending failed",
    failText: "Please try again later or give us a call.",
  },
  footer: {
    text: "Affordable living with registration – free Wi-Fi, free private parking and a shared kitchen. 2 km from Dachau, 18 km from Munich.",
    highlight: "We speak your language!",
    navTitle: "Navigation",
    contactTitle: "Contact",
    top: "Back to top",
  },
  legalLinks: [
    { to: "/impressum", label: "Imprint" },
    { to: "/datenschutz", label: "Privacy policy" },
    { to: "/hausordnung", label: "Booking & house rules" },
  ],
  whatsapp: {
    cta: "Message us on WhatsApp",
    short: "WhatsApp",
    aria: "Open a WhatsApp chat with Pension Günding Gästehaus",
    hint: "Questions? Write to us directly on WhatsApp.",
    hintClose: "Close hint",
    note: "Your message goes straight to our phone – a real person replies, never a bot.",
    prefill:
      "Hello Pension Günding Gästehaus, I have a question about a room (dates, number of guests): ",
  },
  legalBack: "Back to the home page",
  legalGermanNote:
    "For legal reasons the following information is provided in German. Please contact us if you need an explanation in English.",
};

export const content = { de, en };

const LanguageContext = createContext({ lang: "de", t: de, setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "de";
    const stored = window.localStorage.getItem("pg-lang");
    if (stored === "de" || stored === "en") return stored;
    return (window.navigator.language || "de").toLowerCase().startsWith("en") ? "en" : "de";
  });

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      window.localStorage.setItem("pg-lang", next);
    } catch (e) {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: content[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
